import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import React from 'react';
import { Collapse } from '../collapse';
import { Divider } from '../divider';
import { IconExpandLess, IconExpandMore } from '../icon';
import { toArray } from '../utils';
import { Item } from './item';
export const ListItem = React.forwardRef((props, ref) => {
    const { item, divider, children, onMouseEnter, onClick, disableRipple, secondaryAction, sx, className, ...itemProps } = props;
    const [open, setOpen] = React.useState(props.selected);
    const handleClick = () => {
        if (children) {
            setOpen((prevState) => !prevState);
        }
        onClick?.(item);
    };
    React.useEffect(() => {
        if (props.selected) {
            setOpen(true);
        }
    }, [props.selected]);
    if (children) {
        return (_jsxs(_Fragment, { children: [divider === 'top' && _jsx(Divider, {}), _jsxs(MuiListItemButton, { ref: ref, disabled: props.disabled, disableRipple: disableRipple, selected: props.selected && !toArray(children)?.length, onClick: handleClick, onMouseEnter: onMouseEnter, sx: sx, className: className, children: [_jsx(Item, { ...itemProps }), Boolean(toArray(children)?.length) &&
                            (open ? _jsx(IconExpandLess, {}) : _jsx(IconExpandMore, {}))] }), _jsx(Collapse, { in: open, timeout: "auto", unmountOnExit: true, children: _jsx(MuiList, { component: "div", disablePadding: true, children: toArray(children).map((nestedItem, index) => (_jsx(ListItem, { ...nestedItem, onClick: nestedItem.children
                                ? undefined
                                : (item) => {
                                    nestedItem.onClick?.(item);
                                }, sx: sx }, index))) }) }), divider === 'bottom' && _jsx(Divider, {})] }));
    }
    if (onClick) {
        return (_jsxs(_Fragment, { children: [divider === 'top' && _jsx(Divider, {}), _jsx(MuiListItemButton, { ref: ref, disabled: props.disabled, disableRipple: disableRipple, selected: props.selected, onClick: () => onClick(item), onMouseEnter: onMouseEnter, sx: sx, className: className, children: _jsx(Item, { ...itemProps }) }), divider === 'bottom' && _jsx(Divider, {})] }));
    }
    return (_jsxs(_Fragment, { children: [divider === 'top' && _jsx(Divider, {}), _jsx(MuiListItem, { secondaryAction: secondaryAction, sx: sx, className: className, children: _jsx(Item, { ...itemProps }) }), divider === 'bottom' && _jsx(Divider, {})] }));
});
ListItem.displayName = 'ListItem';
